import * as React from 'react';
import classNames from 'classnames';
import { createStyles } from '@material-ui/styles';
import { withStyles } from '@material-ui/core';
import { setProp } from '@topconagriculture/theme';
import Icon from '@material-ui/core/Icon';
const styles = (theme) => createStyles({
    root: {
        fontSize: theme.font.size.mediumBig,
        color: theme.color.font.light,
        display: 'inline-block',
        position: 'relative',
        top: 0,
        left: 0,
        marginLeft: 0,
        marginRight: 0,
        transition: 'inherit',
    },
    disabled: {
        color: theme.color.grey.light,
    },
});
const FontIcon = (props) => {
    const { iconName, className, classes, fromMui, onClick, disabled, testId = `FontIcon-${iconName}` } = props;
    const handleClick = disabled ? null : onClick;
    let inlineStyles = {};
    inlineStyles = setProp(inlineStyles, 'fontSize', props.size);
    inlineStyles = setProp(inlineStyles, 'color', disabled ? null : props.color);
    inlineStyles = setProp(inlineStyles, 'display', props.block && 'block');
    inlineStyles = setProp(inlineStyles, 'top', props.top);
    inlineStyles = setProp(inlineStyles, 'left', props.left);
    inlineStyles = setProp(inlineStyles, 'marginLeft', props.marginLeft);
    inlineStyles = setProp(inlineStyles, 'cursor', props.onClick && !disabled ? 'pointer' : 'inherit');
    inlineStyles = setProp(inlineStyles, 'marginRight', props.marginRight);
    return fromMui ? (React.createElement(Icon, { style: inlineStyles, onClick: handleClick, className: classNames(classes.root, className, disabled ? classes.disabled : null), "data-testid": `${testId}` }, iconName)) : (React.createElement("span", { style: inlineStyles, onClick: handleClick, "data-testid": `${testId}`, className: classNames(classes.root, className, `icon-${iconName}`, disabled ? classes.disabled : null) }));
};
FontIcon.displayName = 'FontIcon';
export default withStyles(styles)(FontIcon);
//# sourceMappingURL=FontIcon.js.map